import React, { useEffect, useState } from 'react';
import SettingContainer from '../SettingContainer';
import { useConfig } from '../../../DataStore/ConfigContext';
import ActivityLoader from '../../Common/ActivityLoader';
import Notification from '../../Common/Notification';
import { useTheme } from '../../../DataStore/ThemeContext';

const Classes = () => {
    const { openSettings } = useTheme();
    const [activeRecord, setActiveRecord] = useState(null);
    const { getClasses, classes } = useConfig();

    useEffect(() => {
        getClasses();
    }, []);

    const handleNew = () => {
        openSettings("New Class", "ConfigNewClass");
    };

    const handleEdit = () => {
        openSettings("Edit Class", "ConfigEditClass", activeRecord);
    };

    const handleCreateStream = () => {
        openSettings("Create Class Stream", "ConfigNewStream", activeRecord);
    };

    const manageStreams = () => {
        openSettings("Manage Streams", "ManageStreams", activeRecord);
    };

    const handleRefresh = () => {
        //clear selection
        setActiveRecord(null);
        getClasses(true);
    };

    const menu = () => (
        <>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleNew}>
                <i className="dropdown-icon fa fa-plus-circle"></i>
                <span>New Class</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleEdit}>
                <i className="dropdown-icon fa fa-edit text-primary"></i>
                <span>Edit Selection</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={handleCreateStream}>
                <i className="dropdown-icon fa fa-plus-circle text-primary"></i>
                <span>Create Stream</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" disabled={!activeRecord} onClick={manageStreams}>
                <i className="dropdown-icon fa fa-th-list text-primary"></i>
                <span>Manage Streams</span>
            </button>
            <button type="button" tabIndex="0" className="dropdown-item" onClick={handleRefresh}>
                <i className="dropdown-icon fa fa-sync text-primary"></i>
                <span>Refresh</span>
            </button>
        </>
    );

    return (
        <SettingContainer title="Classes & Streams" icon="fa fa-school" Menu={menu}>
            <div className="table-responsive">
                <table className="align-middle mb-3 table table-borderless table-striped table-hover">
                    <thead>
                        <tr>
                            <th className="text-left">Class Name</th>
                            <th className="text-left">Level</th>
                            <th className="text-left">Streams</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(classes) && classes.map((item) => (
                            <tr
                                key={item.class_id}
                                onClick={() => setActiveRecord(item)}
                                className={`${item.class_id === activeRecord?.class_id ? 'row-active' : ''}`}
                            >
                                <td className="text-left">{item.class_name}</td>
                                <td className="text-left">{item.level?.level || '-'}</td>
                                <td className="text-left">
                                    {Array.isArray(item.streams)
                                        ? item.streams.map(stream => (
                                            <span key={stream.stream_id} className="badge badge-info mr-1">
                                                {stream.stream_name}
                                            </span>
                                          ))
                                        : <span className="text-muted">No Streams</span>
                                    }
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {classes === '404' && <Notification message="No classes found" />}
                {!classes && <ActivityLoader />}
            </div>
        </SettingContainer>
    );
};

export default Classes;
